module.exports = __webpack_public_path__ + "static/img/b2b228219b1a8c964bb2e9f08b1fa31.cf3335b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/drilling/b2b228219b1a8c964bb2e9f08b1fa31.jpg
// module id = LDkk
// module chunks = 1